import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c("date-picker", {
        staticClass: "my-4",
        attrs: {
          label: "Process Time",
          showTime: "",
          defaultNowOnNull: false,
          "show-hint": false,
          "show-icon": false,
          outlined: "",
        },
        model: {
          value: _vm.worksheet.processTime,
          callback: function ($$v) {
            _vm.$set(_vm.worksheet, "processTime", $$v)
          },
          expression: "worksheet.processTime",
        },
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-4" },
        [
          _c(
            VBtn,
            {
              attrs: { color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }